// Synthetic filter key: shows both manual + digital balance tables in Pending Requests
export const ALL_BALANCE_ADDITIONS = 'allBalanceAdditions';

export enum pendingRequestsTypes {
	BANK_ACCOUNTS = 'bankAccountsRequests',
	BALANCES = 'balancesRequests',
	DIGITAL_BALANCES_REQUESTS = 'digitalBalancesRequests',
	BENEFICIARIES = 'beneficiariesRequests',
	PAYMENTS = 'paymentRequests',
	WITHDRAWAL_SUPPORT = 'withdrawalRequests',
	WITHDRAWAL_BO_APPROVED = 'withdrawalBoApprovedRequests',
	GENERAL_SUPPORT = 'generalRequests',
	CONTACTS = 'contactRequests',
	PAYMENT_FEE = 'paymentFeeRequests',
	CONVERSION = 'conversionRequests',
	BALANCES_BO_REQUESTS = 'balancesBORequests',
	RESEND_WELCOME_EMAIL = 'resend_welcome_email',
	REFUNDS = 'refund',
}

export enum withdrawalOptions {
	REGULAR_WITHDRAWAL = 'regularWithdrawal',
	CLOSE_WITHDRAWAL = 'closeWithdrawal',
}

export enum SupportType {
	General = 'General',
	Withdrawal = 'Withdrawal',
	WithdrawalWithClose = 'WithdrawalWithClose',
}

export const RequestsTypesNeedDialog = [
	pendingRequestsTypes.BALANCES,
	pendingRequestsTypes.BENEFICIARIES,
	pendingRequestsTypes.PAYMENTS,
	pendingRequestsTypes.GENERAL_SUPPORT,
	pendingRequestsTypes.CONTACTS,
	pendingRequestsTypes.BANK_ACCOUNTS,
	pendingRequestsTypes.WITHDRAWAL_SUPPORT,
];

export const RequestsTypesNeedCompanyData = [pendingRequestsTypes.WITHDRAWAL_SUPPORT];

export const DUPLICATE_HIGHLIGHT_TYPES = [
	pendingRequestsTypes.BALANCES,
	pendingRequestsTypes.DIGITAL_BALANCES_REQUESTS,
];

export const ProfileFormsTypesNeedDialog = [pendingRequestsTypes.BALANCES];

export enum SignerDashboardTableType {
	IN_PROGRESS_REQUESTS = 'inProgressRequests',
	COMPLETED_REQUESTS = 'completedRequests',
}

export enum SupportRequestStatus {
	Pending = 'Pending',
	InProgress = 'InProgress',
	Completed = 'Completed',
	Rejected = 'Rejected',
}
